/** A slim strip on every page of the sandbox build so nobody mistakes it for the real site (ADR 0011). */
export function SandboxNotice() {
  return (
    <aside
      aria-label="Sandbox"
      className="border-b border-warning bg-warning-soft px-4 py-1.5 text-center text-sm text-warning-fg"
    >
      <strong className="font-semibold">Sandbox.</strong> Test data that may be reset. The real site is{' '}
      <a href="https://hobbyshelf.net" className="font-medium underline underline-offset-2">
        hobbyshelf.net
      </a>
      .
    </aside>
  );
}
